// services/quotationService.js
import axios from 'axios';

const API_BASE_URL = 'http://staging.maamaas.com:8080/protohub/api';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication if needed
apiClient.interceptors.request.use(
  (config) => {
    // Add token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error('API Error:', error.response.data);
      throw new Error(error.response.data.message || 'Server error occurred');
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.request);
      throw new Error('Network error. Please check your connection.');
    } else {
      // Request setup error
      console.error('Request Error:', error.message);
      throw new Error('Failed to make request');
    }
  }
);

// Quotation API functions
export const quotationService = {
  // Get all quotations for a vendor
  getVendorQuotations: async (vendorId) => {
    try {
      const response = await apiClient.get(`/vendor/quotations/vendor/${vendorId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get quotation by ID
  getQuotationById: async (quotationId) => {
    try {
      const response = await apiClient.get(`/vendor/quotations/${quotationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update quotation status
  updateQuotationStatus: async (quotationId, statusData) => {
    try {
      const response = await apiClient.patch(`/vendor/quotations/${quotationId}/status`, statusData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Submit new quotation
  submitQuotation: async (quotationData) => {
    try {
      const response = await apiClient.post('/vendor/quotations', quotationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete quotation
  deleteQuotation: async (quotationId) => {
    try {
      const response = await apiClient.delete(`/vendor/quotations/${quotationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default quotationService;